// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__11rv8","productName":"Table_productName__3Ys4L"};